<template>
  <div id="app">
    <nav class="navbar navbar-default navbar-static-top">
      <div class="container">
        <div class="navbar-header">

          <!-- Branding Image -->
          <a
            class="navbar-brand"
            :href="appUrl"
            target="_blank">
            {{appName}}
          </a>

<!--          <button type="button" class="collapsed navbar-toggle" data-toggle="collapse" data-target="#main-nav-bar" aria-expanded="false">
            <span class="sr-only">Menu</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>-->
        </div>

        <!-- Menu -->
        <div class="" v-if="user">
          <!-- Left Side Of Navbar -->
          <ul class="nav navbar-nav">
            <li class="dropdown">
              <a href="#" @click="switchDropdown($event)" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Товары<span class="caret"></span></a>
              <ul class="dropdown-menu">
                <li @click="switchDropdown($event)"><router-link to="/products">Товары</router-link></li>
                <li @click="switchDropdown($event)"><router-link to="/categories">Категории</router-link></li>
                <li @click="switchDropdown($event)"><router-link to="/filling">Начинки</router-link></li>
              </ul>
            </li>
            <li class="dropdown">
              <a href="#" @click="switchDropdown($event)" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Маркетинг<span class="caret"></span></a>
              <ul class="dropdown-menu">
                <li @click="switchDropdown($event)"><router-link to="/promotions">Акции</router-link></li>
                <li @click="switchDropdown($event)"><router-link to="/proposals">Предложения</router-link></li>
                <li @click="switchDropdown($event)"><router-link to="/slider">Слайдер</router-link></li>
              </ul>
            </li>

            <!--<li><router-link to="orders">Заказы</router-link></li>-->

            <li @click="closeAllMenus()"><router-link to="/reviews">Отзывы</router-link></li>
            <li @click="closeAllMenus()"><router-link to="/settings/about">О нас</router-link></li>
            <li @click="closeAllMenus()"><router-link to="/settings/static-page">Статические страницы</router-link></li>


            <li class="dropdown">
              <a href="#" @click="switchDropdown($event)" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Настройки<span class="caret"></span></a>
              <ul class="dropdown-menu">
                <li @click="switchDropdown($event)"><router-link to="/settings">Настройки</router-link></li>
                <li @click="switchDropdown($event)"><router-link to="/settings/deliveryhours">Часы доставки</router-link></li>
                <li @click="switchDropdown($event)"><router-link to="/settings/deliveryday">Дни доставки</router-link></li>
                <li @click="switchDropdown($event)"><router-link to="/robots">robots.txt</router-link></li>
              </ul>
            </li>
          </ul>

          <!-- Right Side Of Navbar -->
          <ul class="nav navbar-nav navbar-right">
            <li v-if="user"><a href="" @click="logout()">Выход</a></li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="container">
      <div class="row">
        <div class="col-md-12 col-md-offset-0">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

var config = require('./components/config')

export default {
  name: 'app',
  created () {
    if (!localStorage.getItem('user') && window.location.hash !== '#/login') {
      this.user = false
      this.$router.push('login')
      // window.location.href = '/#/login'
    }

    this.user = localStorage.getItem('user')
  },
  data () {
    return {
      appName: config.appName,
      appUrl: config.appUrl,
      user: false
    }
  },
  beforeRouteUpdate (to, from, next) {
  },
  methods: {
    logout () {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      this.user = false
      this.router.push('login')
    },
    switchDropdown ($event) {
      var $menu = $event.target.closest('.dropdown').querySelector('.dropdown-menu')

      var menus = document.querySelectorAll('.dropdown-menu')
      for (let i = 0; i < menus.length; i++) {
        if (menus[i] !== $menu) {
          menus[i].style.display = ''
        }
      }

      $menu.style.display = $menu.style.display === 'block' ? '' : 'block'
    },
    closeAllMenus () {
      var menus = document.querySelectorAll('.dropdown-menu')
      for (let i = 0; i < menus.length; i++) {
        menus[i].style.display = ''
      }
    }
  }
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
  /*fornt-family: Arial;*/
}

</style>



// WEBPACK FOOTER //
// src/App.vue